export const locale = {
    lang: "es-ES",
    data: {
        DIALOG: {
            TITLE: "Errores al importar usuarios",
            VALIDS: "líneas a importar",

            GRID: {
                LINE: "Línea",
                EMAIL: "Correo Electrónico",
                ERRORS: "Errores"
            },
            COPY: "Copiar error",
            COPY_ALL: "Copiar Todo",
            COPIED: "Errores copiados exitosamente."
        }
    }
};
